<template>
  <div class="rebate-center">
    <div class="rebate-center-wrapper">
      <div class="header">
        <button @click="goback" class="goback"></button>
        <div class="title">我的福利金</div>
        <router-link class="home" to="/home"></router-link>
      </div>
      <div class="can-prepaid">
        <div class="title">可使用福利金</div>
        <div class="prepaid-intro">
          <div class="money-balances">
            <em>{{rebateInfo.account}}</em>
          </div>
          <!-- <router-link to="/voucherCenter">
            <button class="go-prepaid">用福利金充话费</button>
          </router-link> -->
        </div>
      </div>
    </div>
    <!-- swipeable animated -->
    <van-tabs
      :border="false"
      :ellipsis="false"
      background="#fe4f3e"
      color="#fff"
      line-height="4px"
      line-width="48"
      sticky
      title-active-color="#fff"
      title-inactive-color="#fff"
      v-model="current"
    >
      <van-tab :key="index" :title="nav.title" class="nav-tab" v-for="(nav, index) in navList">
        <div class="nav-container">
          <component :is="componentId"></component>
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { Tab, Tabs } from 'vant'
import ChargeRecords from '../components/rebateCenter/ChargeRecords'
import UnavailableRecords from '../components/rebateCenter/UnavailableRecords'
export default {
  name: 'rebateCenter',
  components: {
    VanTab: Tab,
    VanTabs: Tabs,
    ChargeRecords,
    UnavailableRecords
  },
  data () {
    return {
      sticky: false,
      current: 0,
      offsetTop: 0,
      componentId: UnavailableRecords,
      navList: [
        { title: '在途福利金', name: 'UnavailableRecords' },
        { title: '福利金明细', name: 'ChargeRecords' }
      ]
    }
  },
  computed: {
    ...mapState('store', ['rebateInfo'])
  },
  watch: {
    current (newVal) {
      if (newVal === 0) {
        this.componentId = UnavailableRecords
      } else if (newVal === 1) {
        this.componentId = ChargeRecords
      }
    }
  },
  created () {
    this.getRebateInfo()
  },
  methods: {
    ...mapActions('store', [
      'getRebateInfo'
    ]),

    goback () {
      this.$router.back()
    },
    switchTab (i) {
      this.current = i
    },
    jumpDetails () {
      // console.log('跳到详情')
    },

    scrollHandler (e) {
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      this.offsetTop = this.$refs.nav.offsetTop
      // console.log(this.offsetTop)
      if (scrollTop > this.offsetTop - 10) {
        this.sticky = true
      } else {
        this.sticky = false
      }
    }
  }
}
</script>
<style lang="less">
.van-tabs--line .van-tabs__wrap {
  height: 1rem;
}
.rebate-center .van-tab span {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #FEDEAD !important;
}
.rebate-center .van-tabs__nav{
  background: #2D2D3E !important;
}
.rebate-center .van-tabs__line {
  bottom: 0.44rem;
  height: 0.08rem !important;
  background: #FEDEAD !important;
}
</style>
<style lang="less" scoped>
.rebate-center {
  .rebate-center-wrapper {
    // background-color: #fe4f3e;
    background-color: #2D2D3E;
    padding: 0 0.28rem;
    .header {
      width: 100%;
      .flex-between;
      font-size: 0.28rem;
      color: #fff;
      padding: 0.2rem 0 0.27rem;
      .goback,
      .home {
        width: 0.6rem;
        height: 0.6rem;
        background: url("../assets/img/back.png") center no-repeat;
        background-size: 100%;
      }
      .home {
        background: url("../assets/img/back-home.png") center no-repeat;
        background-size: 100%;
      }
    }
    .can-prepaid {
      color: #fff;
      font-size: 0.28rem;
      padding-bottom: 0.5rem;
      // border-bottom: 0.5px solid #ff8f8f;
      .prepaid-intro {
        .flex-between;
        .money-balances {
          em {
            font-size: 0.88rem;
            font-weight: bold;
            padding-right: 0.1rem;
            color: #F0D2A6;
          }
        }
        .go-prepaid {
          padding: 0.2rem;
          font-size: 0.26rem;
          color: #F0D2A6;
          // background-color: #fff;
          opacity: 1;
          border: 1px solid #f0d2a6;
          border-radius: 43px;
        }
      }
    }
  }
}
</style>
